/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { getLatLngByAddress } from "components/AutoCompletePlaces/AutoCompletePlaces";
import useTryCatch from "hooks/useTryCatch";
import { createReservation, updateReservation } from "lib/tripsApi";
import { useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import ROUTES from "routes";
import checkFormFields from "utils/checkFormField";
import usePreviousRoute from "utils/usePreviousRoute";
import useEventRouting from "hooks/useEventRouting";

const useReservationForm = (reservation) => {
  const [isLoading, setIsLoading] = useState(false);
  const { userId, reservationId } = useParams();
  const [formErrors, setFormErrors] = useState({
    passengers: "",
    start_date: "",
    end_date: "",
    stay_name: "",
    address: "",
    room_type: "",
    room_number: "",
    sleeps: "",
  });
  const goBack = usePreviousRoute(ROUTES.dashboard.base);
  const { eventId } = useEventRouting();
  const isCreating = reservationId === "new";
  const isUpdating = reservationId !== "new";
  const onSubmit = useTryCatch(async (e) => {
    e.preventDefault();
    const body = {
      start_date: reservation.start_date,
      end_date: reservation.end_date,
      name: reservation.stay_name,
      address: reservation.address,
      room_type_name: reservation.room_type,
      room_number: reservation.room_number,
      room_capacity: reservation.sleeps,
      companions: Object.keys(reservation.companions).map((id) => id),
    };
    const isValid = checkFormFields({
      "Start Date": reservation.start_date,
      "End Date": reservation.end_date,
      "Stay Name": reservation.stay_name,
      Sleeps: reservation.sleeps,
      Address: reservation.address,
      "Room Type": reservation.room_type,
    });

    if (!isValid) {
      const missingFields = {};
      Object.keys(reservation).forEach((field) => {
        if (!reservation[field] || reservation[field].length === 0) {
          missingFields[field] = "This field is required";
        }
      });
      setFormErrors({
        ...formErrors,
        ...missingFields,
      });
      return;
    }
    const latLng = await getLatLngByAddress(reservation.address);
    body.lat = latLng.lat;
    body.lng = latLng.lng;
    if (!body.lat || !body.lng) {
      toast.error("Please select a valid address", "error");
      return;
    }
    let response;
    if (isCreating) {
      response = await createReservation(body, eventId);
    } else {
      response = await updateReservation(reservationId, body, eventId);
    }
    if (response.ok) {
      goBack();
    }
  }, setIsLoading);
  return {
    isLoading,
    onSubmit,
    formErrors,
    setFormErrors,
  };
};

export default useReservationForm;
